<template>
    <div style="display: inline-block;">
        <div style="display: inline-block;" v-if="isShowProgress">
            <el-progress
                class="qiniu-progress"
                :text-inside="true"
                :stroke-width="18"
                :percentage="percent"
                v-if="showPercent"
            ></el-progress>
            <el-input v-model.trim="fileUrl" class="width_short" maxlength="30" readonly v-else> </el-input>
        </div>
       
        <el-button type="primary" class="upload-qiniu" v-if="!subscription">
            <input type="file" :accept="accept" name="上传" id="uploadQiniuV2"
            @change="fileChange" class="upload-qiniu-input">
            上传
            <i class="el-icon-upload el-icon--right"></i>
        </el-button>
        <el-button type="warning" class="upload-qiniu" v-else
            @click="uploadAbort">
            取消上传
            <i class="el-icon-warning"></i>
        </el-button>
    </div>
</template>

<script scoped>
import commonApi from "@/api/common"
import * as qiniu from 'qiniu-js'
export default {
    name: 'upload-qiniu',
    data() {
        return {
			commonUrl: commonApi.commonUrl,
            action: location.protocol + "//upload-z0.qiniup.com",
            form: {},
            fileUrl: '',
            urlPrefix: '',
            subscription: null,
            file: {},
            percent: 0,
            showPercent: false
        }
    },
    props: {
        multiple: {
            type: Boolean,
            default: false
        },
        isShowProgress: {
            type: Boolean,
            default: false
        },
        accept: {
            type: String,
            default: ""
        },
        url: {
            type: String,
            default: ""
        },
        bucketName: {
            type: String,
            default: commonApi.commonUrl.qNBucketName2
        },
        sizeLimit: { // 兆
            type: Number,
            default: 0
        }
    },
    watch: {
        url(val) {
            this.fileUrl = val
        }
    },
    mounted() {
        this.action = this.getUrl(this.bucketName)
    },
    methods: {
        async uploadBefore(file) {
            // size: 单位 B
            if(this.sizeLimit && (file.size > this.sizeLimit * 1024)) {
                this.$message.warning('文件大小超过限制')
                return null
            }
            this.$emit('on-before', file)
            let key = file.name
            return await this.getQNToken({
                bucketName: this.bucketName,
                fileName: key
            })
            // this.form = form
            // return true
        },
        async fileChange(e) {
            const file = e.target.files[0]
            this.file = file
            document.getElementById('uploadQiniuV2').value = ''
            const form = await this.uploadBefore(file)
            if(!form) { return }
            const putExtra = {
                fname: file.name,
                MimeType: this.accept
            }
            const config = {
                region: this.getUrl(this.bucketName)
            }
            const observable = qiniu.upload(file, form.key, form.token, putExtra)
            if(this.subscription) {
                this.subscription.unsubscribe() // 已有上传内容，先取消上一次上传
            }
            this.subscription = observable.subscribe(
                this.uploadProgress, // next: 进度回调
                this.uploadError, // error：出错回调
                this.uploadSuccess // complete：成功回调
            ) // 上传开始
        },
        uploadAbort() {
            if(!this.subscription) { return }
            this.subscription.unsubscribe() // 上传取消
            this.showPercent = false
            this.subscription = null
            this.$emit('on-abort')
        },
        uploadProgress(res) {
            let percent = res.total.percent
            this.percent = parseFloat(percent.toFixed(1))
            this.showPercent = true
            this.$emit('on-progress', {
                event: res.total
            })
        },
        uploadSuccess(res) {
            this.showPercent = false
            this.percent = 0
            this.fileUrl = this.urlPrefix + res.key
            this.$emit('on-success', {
                key: res.key,
                url: this.urlPrefix + res.key,
                file: this.file
            })
            this.subscription = null
        },
        uploadError(err) {
            console.log(err)
            this.showPercent = false
            this.percent = 0
            try {
                 this.$message({
                    showClose: true,
                    type: 'error',
                    message: err,
                    duration: 0
                })
                this.$emit('on-error', {
                    err: err.message
                })
                this.subscription = null
            } catch (e) {
                console.log(e)
            }
        },
        getQNToken(req) {
            return new Promise((resolve, reject) => {
                commonApi.getQNUploadToken(req).then(res => {
                    if(res.Success){
                        resolve(res.Data)
                    }else{
                        reject()
                        this.$message.error(res.Msg)
                    }
                })
            })
        },
        getUrl(bucketName) {
            let url = ""
            switch(bucketName) {
                case 'ibaby-autolive-dev': url = 'https://upload-z1.qiniup.com', this.urlPrefix = this.commonUrl.qnPrefix; break;
                case 'ibaby-autolive': url = 'https://upload-z1.qiniup.com', this.urlPrefix = this.commonUrl.qnPrefix; break;
                case 'ibaby': url = 'https://upload-z0.qiniup.com', this.urlPrefix = this.commonUrl.qnPrefix2; break;
                case 'ibabytest': url = 'https://upload-z0.qiniup.com', this.urlPrefix = this.commonUrl.qnPrefix2; break;
            }
            return url
        }
    },
    destroyed() {
        this.uploadAbort()
    }
}
</script>

<style lang="less" scoped>
.upload-qiniu{
    position: relative;
    overflow: hidden;
    .upload-qiniu-input{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0;
        cursor: pointer;
    }
}
.qiniu-progress {
    width: 21%;
    min-width: 300px;
    margin-top: 10px;
    display: inline-block;
    .el-progress-bar__innerText {
        transform: scale(0.8) translateY(-4px);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/upload-qiniu-v2.vue